// Top-level tabs for the program enrollments list (§6.3). The tab acts as a
// coarse status filter; only the "all" tab exposes the fine-grained status /
// source / sort filters. `status === null` means "don't force a status" (the
// "all" tab defers to the user-controlled ChipPicker filters).
// Built from the caller's `t` so the labels follow the active language.
export const getEnrollmentTabs = (t) => [
  { key: "all", label: t("enrollmentTabs.all"), status: null },
  { key: "active", label: t("enrollmentTabs.active"), status: ["active"] },
  { key: "pending", label: t("enrollmentTabs.pending"), status: ["pending"] },
];

export const DEFAULT_ENROLLMENT_TAB = "all";

// Tab key → forced status list (or null for the "all" tab).
export const ENROLLMENT_TAB_STATUS = {
  all: null,
  active: ["active"],
  pending: ["pending"],
};

// The tab the pending-approvals card / count badge points at.
export const PENDING_TAB = "pending";
